import styles from './Actions.module.scss'

export function Action({
	'data-testid': dataTestId,
	label,
	onClick,
}: {
	readonly 'data-testid'?: string
	readonly label: string
	readonly onClick: () => void
}) {
	return (
		<button
			data-testid={dataTestId}
			type='button'
			className={styles.action}
			onClick={onClick}
		>
			{label}
		</button>
	)
}
